import React from "react";
import { Card } from "react-bootstrap";
import ReactECharts from "echarts-for-react";
import _ from "lodash";
import Spinner from "../../../../../../../utils/Spinner";

const CountDisGraph = (props) => {
  const rowdatareceived = props.data;
  const fetching = props.fetching;
  let metricValue = _.uniq(_.map(rowdatareceived, "metricValue"));
  let updatedAt = _.uniq(_.map(rowdatareceived, "updatedAt"));

  const option = {
    color: "#00786B",
    tooltip: [
      {
        formatter: function (params) {
          return `Updated At : ${params.name}
          <br/> Metric Value : ${params.value} `;
        },
        backgroundColor: "#323437",
        textStyle: {
          color: "white",
        },
      },
    ],
    xAxis: {
      type: "category",
      data: updatedAt,
    },
    title: {
      left: "",
      top: 0,
      textStyle: {
        color: "black",
      },
    },
    yAxis: {
      type: "value",
      nameGap: "65",
    },
    series: [
      {
        data: metricValue,
        type: "bar",
      },
    ],
  };

  return (
    <React.Fragment>
      <Card className="margin__gr">
        {fetching ? (
          <div className="justify-content-md-center">
            {" "}
            <Spinner />
          </div>
        ) : (
          <ReactECharts option={option} className="inner__values" />
        )}
      </Card>
    </React.Fragment>
  );
};
export default CountDisGraph;
